import React from "react";
import "./button-schedule.scss";

const ButtonSchedule = (props: ButtonInterface) => {
  const { name, active, setbuttonActive, schedule, gtm } = props;
  return (
    <>
      {schedule ? (
        <button
          className={`a-button-schedule primary no-border schedule${
            active ? "--active" : ""
          }  ${gtm} `}
          onClick={() => {
            active ? setbuttonActive("") : setbuttonActive(name);
          }}
        >
          {name}
        </button>
      ) : (
        <button
          className={`a-button-schedule primary no-border${
            active ? "--active" : ""
          }  ${gtm}`}
          onClick={() => {
            active ? setbuttonActive("") : setbuttonActive(name);
          }}
        >
          {name}
        </button>
      )}
    </>
  );
};

interface ButtonInterface {
  name: string;
  active: boolean;
  setbuttonActive: any;
  schedule?: boolean;
  gtm?: string;
}

export default ButtonSchedule;
